import React from 'react'

export default function SalesForceFieldLink(props) {
  return (
    <span>
      {props.text}
      <a
        href={extConfig.SF_FIELD_LINK + props.id}
        target='_blank'
        className='pull-right'
        style={{ paddingRight: '1rem' }}
      >
        Salesforce <i className='fa fa-external-link' aria-hidden='true' />
      </a>
    </span>
  )
}



// WEBPACK FOOTER //
// ./src/components/salesForceFieldLink.js